import { TranslationRecord } from '../../../TranslationRecord';
import { plTranslations } from '../../../global-translations/pl';

export const plMessages: TranslationRecord = {
  ...plTranslations,
  FORM_TITLE: 'Zamów Assistance, wyślij zdjęcie z miejsca zdarzenia',
  INFO_CARD_CONTENT_1:
    '1. Dodajesz zdjęcie z wypadku z widoczną tablicą rejestracyjną. Ze zdjęcia odczytamy miejsce zdarzenia.\n',
};
